
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, ExameType, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class ExameTypeListProvider implements Resolve<any> {
    exameType: ExameType[];
    exameTypeEdit: ExameType;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.exameTypeEdit = this.state?.currentExameType;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
            this.pageOptions.fieldSort = 'name';
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'name';
        }
        return new Promise((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    get(id: number): Observable<ExameType> {
        if (!id) {
            return null;
        }
        return this.gw.get('exameType/:id', { id: id });
    }

    get currentExameType(): ExameType {
        return this.exameTypeEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('exameType/').subscribe({
                next: (res: HttpResponse<any>) => {
                    this.exameType = res.body;
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('exameType/search', pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (!CwUtils.compare(this.exameType, res.body.content) && res.body.content.length > 0) {
                        this.exameType = res.body.content;
                        this.onDataChanged.next(this.exameType);
                    }
                    else {
                        this.exameType = res.body.content;
                    };
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

